import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";

export default function CommonModal({ open, closeModal, title, content }) {
  return (
    <>
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <h4 style={{ padding: "16px 24px", marginBottom: 0 }}>{title}</h4>
        <hr style={{margin: "2px"}}/>
        <div style={{ padding: "16px 24px", marginBottom: 0 }}>{content}</div>
        <DialogActions>
          <span
            onClick={closeModal}
            autoFocus
            className="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-dark margin_right10"
            style={{cursor: "pointer"}}
          >
            Close
          </span>
        </DialogActions>
      </Dialog>
    </>
  );
}
